<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="500" scrollable>
      <v-card>
        <v-btn
          fab
          @click="scrollToBottom"
          style="position: absolute; right: 6px; bottom: 10px; z-index: 1"
          color="grey darken-2"
          small
          v-if="showScrollIcon"
          class="mx-2"
        >
          <v-icon color="white" size="24">mdi-arrow-down </v-icon>
        </v-btn>

        <v-card-title>
          <span class="text-h5"> {{ $t("termAndCondition") }}</span>
        </v-card-title>
        <v-card-text
          @scroll="handleScroll"
          ref="scrollContainer"
          style="max-height: 90vh; overflow-y: auto"
        >
          <v-row>
            <v-col col="12">
              <div
                class="ql-editor"
                style="height: fit-content"
                v-html="formatCondition(condition)"
              ></div>
            </v-col>
          </v-row>
          <v-row>
            <v-col col="12">
              <div class="d-flex" ref="scrollTarget">
                <v-spacer></v-spacer>
                <v-btn
                  :color="site.color"
                  outlined
                  @click="handleCancel()"
                  class="mr-2"
                >
                  {{ $t("disagree") }}
                </v-btn>
                <v-btn
                  :color="site.color"
                  class="white--text"
                  depressed
                  @click="handleConfirm()"
                >
                  {{ $t("agree") }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";

export default {
  inject: ["isAppLoading"],
  data() {
    return {
      dialog: false,
      condition: "",
      showScrollIcon: false,
    };
  },
  methods: {
    handleScroll() {
      const el = this.$refs.scrollContainer;
      if (!el) return;

      const threshold = 20;
      const bottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;

      this.showScrollIcon = !bottom;
    },
    scrollToBottom() {
      if (!this.$refs.scrollContainer) return;
      this.$refs.scrollContainer.scrollTo({
        top: this.$refs.scrollContainer.scrollHeight,
        behavior: "smooth",
      });
    },
    handleCancel() {
      this.logout();
    },
    handleConfirm() {
      this.onConfirmConsent();
    },
    async logout() {
      this.logoutAndClear();
    },
    logoutAndClear() {
      this.isAppLoading(true);

      Axios.post("logout")
        .then(() => {
          //
        })
        .catch((err) => {
          console.log("error:logoutAndClear", err);
        })
        .finally(() => {
          localStorage.clear();
          localStorage.setItem("is_logout", "1");
          setTimeout(() => {
            location.reload();
          }, 500);
        });
    },
    getProfileLocal() {
      return new Promise((resolve) => {
        Axios.get("getProfile")
          .then(({ data }) => {
            let dataResponse = null;
            if (data.status == "success") {
              dataResponse = { ...data.data };
            }
            resolve(dataResponse);
          })
          .catch((err) => {
            console.log("ModalConsent:getProfileLocal", err);
            resolve(null);
          });
      });
    },
    onConfirmConsent() {
      this.isAppLoading(true);
      Axios.post("comfirmConsent")
        .then(({ data }) => {
          if (data.status == "success") {
            this.dialog = false;
          } else {
            this.logout();
          }
        })
        .catch((err) => {
          console.log("onConfirmConsent:comfirmConsent", err);
          this.logout();
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    getCondition() {
      Axios.get(`getCondition?site_id=${this.site?.id}`)
        .then(async (res) => {
          if (res.data.status === "success") {
            this.condition = res.data.condition;
            if (!this.condition) {
              this.condition = `<div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">${this.$t(
                "dataNotFound"
              )}</div>`;
            } else {
              const _customer = await this.getProfileLocal();
              if (_customer.code && !_customer.status_consent) {
                this.dialog = true;
              }
            }
          }
        })
        .catch((err) => {
          console.log("ModalConsent:getCondition", err);
          this.condition = `<div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">${this.$t(
            "dataNotFound"
          )}</div>`;
        });
    },
    formatCondition(param) {
      let html = param || "";
      if (html.includes("<iframe")) {
        html = html.replaceAll("<iframe", "<iframe style='max-width: 100%;'");
      }
      if (html.includes("<img")) {
        html = html.replaceAll(
          "<img",
          "<img style='max-width: 100%;width: auto !important;height: auto !important;'"
        );
      }
      return html;
    },
  },
  created() {},
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
  },
  watch: {
    customer: {
      handler() {
        if (this.customer) {
          if (!this.customer.status_consent) {
            this.getCondition();
          }
        }
      },
      deep: true,
    },
  },
};
</script>
